import { Component } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { Auth } from '../../providers/auth/auth';

@Component({
  selector: 'ww-footer',
  templateUrl: 'footer.html'
})
export class FooterComponent {

  text: string;
  user: string;
  loggedInMessage: string;
  public isLoggedIn = false;
  subscription: Subscription;
  userSubscription: Subscription;
  public fullYear: number = new Date().getFullYear();

  constructor(public authService: Auth) {

    this.subscription = this.authService.isLoggedIn$
      .subscribe((isConnected) => {
        this.isLoggedIn = isConnected
      })

    this.userSubscription = this.authService.isUser$
      .subscribe((user: any) => {
        this.user = user
      })
  }
  logout() {
    // this.navCtrl.setRoot('HomePage');
    this.authService.logout();
  }
}



// WEBPACK FOOTER //
// ./src/components/footer/footer.ts